import React, { useState } from 'react';
import '../CSS/EdTech.css';

const EdTech: React.FC = () => {
  const [activeCollapsible, setActiveCollapsible] = useState(0);

  const handleCollapsibleClick = (index: number) => {
    setActiveCollapsible(index);
  };

  return (
    <div className="edtech-page">
      <div className="edtech_banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">EdTech</h1>
        </div>
      </div>

      <div className="ed_tech_facts">
        <div className="facts-content">
          {/* Left Side - Text */}
          <div className="facts-text">
            <p>We help educational institutes transform learning practices to address tomorrow's challenges of interacting, educating, learning, and <span className="gradient-text">progressing.</span></p>
          </div>

          {/* Right Side - Collapsible Boxes */}
          <div className="facts-collapsibles edtech-collapsible-cards">
            <div 
              className={`collapsible-item ${activeCollapsible === 0 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(0)}
            >
              <div className="collapsible-header">
                <div className="collapsible-icon">
                  <img src="/Assets/Icons/platform-learning-teaching-icon.svg" alt="Platform for Learning and Teaching" />
                </div>
                <h3 className="collapsible-title">Platform for Learning and Teaching</h3>
                <div className="collapsible-arrow">
                  <img 
                    src={activeCollapsible === 0 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 0 && (
                <div className="collapsible-content">
                  <ul>
                    <li>Collaborative Education</li>
                    <li>Fully Configurable LMS Platforms</li>
                    <li>Adaptive Learning Engines</li>
                  </ul>
                </div>
              )}
            </div>

            <div 
              className={`collapsible-item ${activeCollapsible === 1 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(1)}
            >
              <div className="collapsible-header">
                <div className="collapsible-icon">
                  <img src="/Assets/Icons/interactive-learning-experiences-icon.svg" alt="Interactive Learning Experiences" />
                </div>
                <h3 className="collapsible-title">Interactive Learning Experiences</h3>
                <div className="collapsible-arrow">
                  <img 
                    src={activeCollapsible === 1 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 1 && (
                <div className="collapsible-content">
                  <ul>
                    <li>Cross-Platform Interactive Content Development</li>
                    <li>Mobile Learning</li>
                  </ul>
                </div>
              )}
            </div>

            <div 
              className={`collapsible-item ${activeCollapsible === 2 ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(2)}
            >
              <div className="collapsible-header">
                <div className="collapsible-icon">
                  <img src="/Assets/Icons/data-analytics-icon.svg" alt="Data Analytics for Educational Institutions" />
                </div>
                <h3 className="collapsible-title">Data Analytics for Educational Institutions</h3>
                <div className="collapsible-arrow">
                  <img 
                    src={activeCollapsible === 2 ? "/Assets/Icons/up-arrow-icon.svg" : "/Assets/Icons/down-arrow-icon.svg"} 
                    alt="Toggle" 
                  />
                </div>
              </div>
              {activeCollapsible === 2 && (
                <div className="collapsible-content">
                  <ul>
                    <li>Data Analytics and Reporting</li>
                    <li>Data Processing</li>
                    <li>Customizable Content Engineering</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* EdTech Pairing Section - Desktop */}
      <div className="ed_tech_pairing desktop-edtech-pairing">
        <div className="ed_tech_pairing-content">
          {/* Main Title */}
          <h2 className="ed_tech_pairing-title">EdTech Development Services</h2>

          {/* First Pairing - Real-time Analytics and Reporting */}
          <div className="edtech_image_right">
          <div className="section-image">
              <img src="/Assets/Edtech/real-time-analytics-section-image.png" alt="Real-Time Analytics and Reporting" />
            </div>
            <div className="edtech_section_text">
              <h3 className="edtech_section_title">Real-Time Analytics and Reporting Management Software</h3>
              <p className="edtech_section_description">We build edtech software that can help educational institutes track students' and teachers' performance along with all activity data. The software produces powerful insights to improve productivity.</p>
            </div>

          </div>

          {/* Second Pairing - Staff and Teacher Management */}
          <div className="edtech_image_left">
            <div className="section-image">
              <img src="/Assets/Edtech/staff-teacher-management-soft-section-image.png" alt="Staff and Teacher Management Software" />
            </div>
            <div className="edtech_section_text">
              <h3 className="edtech_section_title">Staff and Teacher Management Software</h3>
              <p className="edtech_section_description">We develop comprehensive management systems that streamline administrative tasks, track teacher performance, and facilitate communication between staff members and administrators.</p>
            </div>
          </div>

          {/* Third Pairing - Real-time Collaboration and Video Communication */}
          <div className="edtech_image_right">
            <div className="section-image">
              <img src="/Assets/Edtech/real-time-collaboration-section-image.png" alt="Real-time Collaboration and Video Communication" />
            </div>
            <div className="edtech_section_text">
              <h3 className="edtech_section_title">Real-time Collaboration and Video Communication</h3>
              <p className="edtech_section_description">We develop WebRTC-based highly customizable scheduling and virtual meeting solution for e-learning, corporate training, online assessments, and group collaboration.</p>
            </div>
          </div>

          {/* Fourth Pairing - Educational App Development */}
          <div className="edtech_image_left">
            <div className="section-image">
              <img src="/Assets/Edtech/educational-app-development-section-image.png" alt="Educational App Development" />
            </div>
            <div className="edtech_section_text">
              <h3 className="edtech_section_title">Educational App Development</h3>
              <p className="edtech_section_description">We use technologies, including React Native and Xamarin to build interactive and student-friendly mobile apps that comprise various innovative features such as video-calling, live classrooms and animated graphics for better learning.</p>
            </div>
          </div>

          {/* Fifth Pairing - Content Creation and Management Software */}
          <div className="edtech_image_right">
            <div className="section-image">
              <img src="/Assets/Edtech/content-creation-section-image.png" alt="Content Creation and Management Software" />
            </div>
            <div className="edtech_section_text">
              <h3 className="edtech_section_title">Content Creation and Management Software</h3>
              <p className="edtech_section_description">We develop a robust content management system that allows faculties and admins to upload a wide array of content, including videos, images, animated graphics, GIFs, and audio. Using interactive plugins, faculties can upload content in different forms.</p>
            </div>
          </div>

          {/* Sixth Pairing - LMS Integration */}
          <div className="edtech_image_left">
            <div className="section-image">
              <img src="/Assets/Edtech/lms-integration-section-image.png" alt="LMS Integration" />
            </div>
            <div className="edtech_section_text">
              <h3 className="edtech_section_title">LMS Integration</h3>
              <p className="edtech_section_description">We provide seamless integration services for Learning Management Systems, connecting various educational tools and platforms to create a unified learning environment that enhances the educational experience.</p>
            </div>
          </div>
        </div>
      </div>

      {/* EdTech Pairing Section - Mobile (480px) */}
      <div className="ed_tech_pairing mobile-edtech-pairing">
        <div className="ed_tech_pairing-content">
          {/* Main Title */}
          <h2 className="ed_tech_pairing-title">EdTech Development Services</h2>

          {/* First Pairing - Real-time Analytics and Reporting - Text Above Image */}
          <div className="mobile-edtech-section">
            <div className="mobile-edtech-text">
              <h3 className="mobile-edtech-title">Real-Time Analytics and Reporting Management Software</h3>
              <p className="mobile-edtech-description">We build edtech software that can help educational institutes track students' and teachers' performance along with all activity data. The software produces powerful insights to improve productivity.</p>
            </div>
            <div className="mobile-edtech-image">
              <img src="/Assets/Edtech/real-time-analytics-section-image.png" alt="Real-Time Analytics and Reporting" />
            </div>
          </div>

          {/* Second Pairing - Staff and Teacher Management - Text Above Image */}
          <div className="mobile-edtech-section">
            <div className="mobile-edtech-text">
              <h3 className="mobile-edtech-title">Staff and Teacher Management Software</h3>
              <p className="mobile-edtech-description">We develop comprehensive management systems that streamline administrative tasks, track teacher performance, and facilitate communication between staff members and administrators.</p>
            </div>
            <div className="mobile-edtech-image">
              <img src="/Assets/Edtech/staff-teacher-management-soft-section-image.png" alt="Staff and Teacher Management Software" />
            </div>
          </div>

          {/* Third Pairing - Real-time Collaboration and Video Communication - Text Above Image */}
          <div className="mobile-edtech-section">
            <div className="mobile-edtech-text">
              <h3 className="mobile-edtech-title">Real-time Collaboration and Video Communication</h3>
              <p className="mobile-edtech-description">We develop WebRTC-based highly customizable scheduling and virtual meeting solution for e-learning, corporate training, online assessments, and group collaboration.</p>
            </div>
            <div className="mobile-edtech-image">
              <img src="/Assets/Edtech/real-time-collaboration-section-image.png" alt="Real-time Collaboration and Video Communication" />
            </div>
          </div>

          {/* Fourth Pairing - Educational App Development - Text Above Image */}
          <div className="mobile-edtech-section">
            <div className="mobile-edtech-text">
              <h3 className="mobile-edtech-title">Educational App Development</h3>
              <p className="mobile-edtech-description">We use technologies, including React Native and Xamarin to build interactive and student-friendly mobile apps that comprise various innovative features such as video-calling, live classrooms and animated graphics for better learning.</p>
            </div>
            <div className="mobile-edtech-image">
              <img src="/Assets/Edtech/educational-app-development-section-image.png" alt="Educational App Development" />
            </div>
          </div>

          {/* Fifth Pairing - Content Creation and Management Software - Text Above Image */}
          <div className="mobile-edtech-section">
            <div className="mobile-edtech-text">
              <h3 className="mobile-edtech-title">Content Creation and Management Software</h3>
              <p className="mobile-edtech-description">We develop a robust content management system that allows faculties and admins to upload a wide array of content, including videos, images, animated graphics, GIFs, and audio. Using interactive plugins, faculties can upload content in different forms.</p>
            </div>
            <div className="mobile-edtech-image">
              <img src="/Assets/Edtech/content-creation-section-image.png" alt="Content Creation and Management Software" />
            </div>
          </div>

          {/* Sixth Pairing - LMS Integration - Text Above Image */}
          <div className="mobile-edtech-section">
            <div className="mobile-edtech-text">
              <h3 className="mobile-edtech-title">LMS Integration</h3>
              <p className="mobile-edtech-description">We provide seamless integration services for Learning Management Systems, connecting various educational tools and platforms to create a unified learning environment that enhances the educational experience.</p>
            </div>
            <div className="mobile-edtech-image">
              <img src="/Assets/Edtech/lms-integration-section-image.png" alt="LMS Integration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdTech; 